export const matchesPlatformSummary = (product, platform, {
    productPlatformIds = [], glovoPlatformIds = new Set(), kooulPlatformIds = new Set(),
} = {}) => {
    switch (platform) {
        case 'glovo':
            return Array.from(productPlatformIds).some((id) => glovoPlatformIds.has(id))
                || (!glovoPlatformIds.size && (Array.isArray(product?.glovo_id)
                    ? product.glovo_id.length > 0 : Boolean(product?.glovo_id)));
        case 'kooul':
            return Array.from(productPlatformIds).some((id) => kooulPlatformIds.has(id));
        case 'woocommerce':
            return product?.woocommerce_id !== null && product?.woocommerce_id !== undefined;
        case 'marjaneActive':
            return product?.marjane?.status === 'active';
        default:
            return true;
    }
};
